let winSize = false;

function getInnerSize(e) {
    let innerWidth = window.innerWidth;
    let innerHeight = window.innerHeight;
    if (Q3.browserCapabilities.isMobile) {
        if (!winSize) {
            winSize = {
                w: innerWidth,
                h: innerHeight
            }
        } else if (e && e.type !== "orientationchange") {
            let deltaH = window.innerHeight - winSize.h;
            if (deltaH < 0 && Math.abs(deltaH) > winSize.h * 0.25) {
                innerWidth = winSize.w;
                innerHeight = winSize.h;
            } else {
                winSize.w = window.innerWidth;
                winSize.h = window.innerHeight;
            }
        } else {
            winSize.w = window.innerWidth;
            winSize.h = window.innerHeight;
        }
    }

    return { innerWidth, innerHeight };
}

export default getInnerSize;
export { getInnerSize };